/**
 * Enum of endpoint suffixes available from the server.
 */
export enum EndPoint {
  AccountSettings = 'account-settings',
  Admins = 'admins',
  CustomFields = 'custom-fields',
  DailyChecks = 'daily-checks',
  Datasets = 'datasets',
  Devices = 'devices',
  EmailTemplates = 'email-templates',
  Events = 'events',
  Files = 'files',
  FitTests = 'fit-tests',
  Masks = 'masks',
  MedicalClearances = 'medical-clearances',
  People = 'people',
  Views = 'views'
}
